import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api.service';

@Component({
  selector: 'app-purchase-order-archive',
  templateUrl: './purchase-order-archive.component.html',
  styleUrls: ['./purchase-order-archive.component.scss']
})

export class PurchaseOrderArchiveComponent {
  sku_data: any[];
  archive_data: any[];
  expandedElement: number | null = null;
  po_id: any;
  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PurchaseOrderArchiveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: any; }
  ) {
    this.po_id = data?.id;
    console.log('type', data?.id);
    this.fetchData()
  }

  fetchData() {
    const payload = {
      po_id: this.po_id,
    };
    this.apiService.fetchpoarchive(payload).subscribe(
      (response) => {
        this.archive_data = response.data;
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  poDetails(Id: number) {
    this.sku_data = this.archive_data.filter(item => item.id === Id);
    console.log('po details', this.sku_data);
  }
  toggleTable(item: any) {
    if (this.expandedElement === item.id) {
      this.expandedElement = null;
    } else {
      this.expandedElement = item.id;
    }
  }
}
